
class GlobalNav
{
  // ---------------------------------------------------------------------------------------------------------
	// --	GlobalNav
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    //DOM参照
    this.$gnav = $('.sc-header__gnav');
    this.$menu = $('.sc-header__burger-menu');

    //メニューを押したらis-openクラスを付与
    this.$menu.on('click', () => {
      this.$gnav.toggleClass('is-open');
      this.$menu.toggleClass('is-open');
    });
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default GlobalNav